import { AssistantValue } from "../../../services/api/instances/assistantsApi/types";
import { TStoreData } from "../../../services/api/instances/vectorStoreApi/types";
import { getUpdatedValue } from "./getUpdatedValue";

export const getValueWithStoreData = (
  store: TStoreData | null,
  assistantValue: AssistantValue,
) => {
  const toolsWithoutFileSearch = assistantValue.assistant_object.tools.filter(
    (tool) => tool.type !== "file_search",
  );
  let newValue: AssistantValue;
  if (store === null) {
    newValue = getUpdatedValue(
      assistantValue,
      {
        tool_resources: {
          code_interpreter: { file_ids: [] },
        },
        tools: [...toolsWithoutFileSearch, { type: "code_interpreter" }],
      },
      {
        ...assistantValue.meta,
        store_type: "openai",
      },
    );
    return newValue;
  } else if (store) {
    newValue = getUpdatedValue(
      assistantValue,
      {
        tool_resources: {
          file_search: {
            vector_store_ids: [store?.id],
          },
        },
        tools: [
          ...toolsWithoutFileSearch.filter(
            (tool) => tool.type !== "code_interpreter",
          ),
          {
            type: "file_search",
          },
        ],
      },
      {
        ...assistantValue.meta,
        store_type: store.metadata.type,
      },
    );
    return newValue;
  }
  return assistantValue;
};
